import { render, staticRenderFns } from "./AddonTwitterLogin.vue?vue&type=template&id=d790fe9a&"
import script from "./AddonTwitterLogin.vue?vue&type=script&lang=js&"
export * from "./AddonTwitterLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports